import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getAuth } from 'firebase/auth';
import { getAnalytics } from 'firebase/analytics';

const config = {
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
  appId: import.meta.env.VITE_FIREBASE_APP_ID,
  measurementId: import.meta.env.VITE_FIREBASE_MEASUREMENT_ID,
};

const app = initializeApp(config);

export const firestoreDb = getFirestore(
  app,
  import.meta.env.VITE_FIREBASE_FIRESTORE_NAME
    ? import.meta.env.VITE_FIREBASE_FIRESTORE_NAME
    : undefined
);
export const auth = getAuth(app);
export const analytics = getAnalytics(app);

export default app;
